<script lang="ts">
    import '../app.css'
    import { onDestroy } from 'svelte'
    import { invalidateAll } from '$app/navigation'
    import favicon from '$lib/assets/favicon.ico'
    import { getTextDirection } from '$lib/paraglide/runtime.js'
    import { invalidateRouteAuthorizationOnAuthenticationChange } from '$lib/routing/auth-routing.js'
    import { setAppContext } from '$lib/context/app-context.svelte.js'
    import { setAppServices } from '$lib/services/app-services.js'
    import { getAppRuntime } from '$lib/runtime/app-runtime.js'
    import AuthRouteTransitions from '$lib/ui/auth/AuthRouteTransitions.svelte'
    import SocialLoginNavigationFeedback from '$lib/ui/auth/SocialLoginNavigationFeedback.svelte'
    import AccountDeletionManualRemovalNotice from '$lib/ui/profile/delete-account/AccountDeletionManualRemovalNotice.svelte'

    let { children } = $props()

    const { appContext, appServices } = getAppRuntime()
    const { locale } = appServices

    setAppContext(appContext)
    setAppServices(appServices)

    const unsubscribe = appServices.auth.subscribe(({ current, previous }) => {
        invalidateRouteAuthorizationOnAuthenticationChange(previous, current, invalidateAll)
    })

    const textDirection = $derived(getTextDirection(locale.current))

    // Author note: document language and direction are external DOM state owned by the app root.
    // A derived value cannot apply those attributes, element attachments do not target the root
    // document element, and event handlers do not cover locale changes from every app surface.
    $effect(() => {
        const currentLocale = locale.current

        document.documentElement.lang = currentLocale
        document.documentElement.dir = textDirection
    })

    onDestroy(unsubscribe)
</script>

<svelte:head>
    <link rel="icon" href={favicon} />
</svelte:head>

<AuthRouteTransitions />
<SocialLoginNavigationFeedback />
{#key locale.accountRevision}
    {@render children()}
    <AccountDeletionManualRemovalNotice />
{/key}
